export default __webpack_public_path__ + "static/logo-178df6f5e2c7a4d29aba0d8c2523143d.gif";